// HERO SCROLL

const heroOverylay = document.querySelector(".hero_overlay")

const heroScroll = gsap.timeline({
  scrollTrigger: {
    trigger: ".section_hero",
    start: "top top",
    end: "bottom top",
    scrub: true,
    ease: "none"
  },
});

heroScroll.fromTo(".hero_overlay", {
  opacity: 0
}, {
  opacity: 0.15
}).to(".big-marquee", {
  y: "-2.5rem",
  ease: "none"
}, "<")


const preloader = document.querySelector(".preloader_comp");

if (preloader) {

  const preloaderLoadBar = document.querySelector(".preloader_overlay");
  const preloaderTimer = document.querySelector("#loadtext");

  // Animate the loading bar with a GSAP timeline
  const preloaderTl = gsap.timeline({
    onUpdate: updateTimer,
    onComplete: () => {
      gsap.fromTo(preloader, {
        clipPath: "inset(0% 0% 0% 0%)"
      }, {
        clipPath: "inset(0% 100% 0% 0%)",
        duration: 0.45,
        ease: "myCustomEase"
      })
      pageOpen.play();
    }

  });

  preloaderTl.to(preloaderLoadBar, {
    width: "0%",
    duration: 1,
    ease: "slow(0.7,0.7,false)",
  })

  function updateTimer() {

    const progress = Math.round(preloaderTl.progress() * 100);

    preloaderTimer.textContent = `${progress.toString().padStart(3, '0')}%`;

    document.getElementById("loadtext").innerHTML = progress.toString().padStart(3, "0");
  }

  preloaderTl.play();

  const pageOpen = gsap.timeline({
    paused: true,
    defaults: { ease: "myCustomEase" },
    ease: "expo.inOut",
    delay: 0.2,
  })

  pageOpen.from(".intro_line", {
      height: 0,
      opacity: 0.8,
      duration: 1.5,
      ease: "expo.out",
    }).from(".hero_line-horizontal", {
      width: 0,
      opacity: 0.8,
      duration: 1.5,
      ease: "expo.out",
    }, "<0.1")
    .from(".section_hero [split] span", {
      opacity: 0,
      filter: "blur(1px)",
      y: "-30%",
      duration: 2.25,
      ease: "expo.out",
      stagger: { amount: 0.35, ease: "none", }
    }, "<0.1").from(".hero_p", {
      x: "3rem",
      opacity: 0,
      duration: 0.75,
      ease: "power2.out"
    }, "<")
    .from(".hero_buttons .button", {
      x: "3.5rem",
      opacity: 0,
      duration: 0.75,
      ease: "power2.out"
    }, "<0.1").from(".hero_buttons .button-w", {
      y: "1.5rem",
      opacity: 0,
      duration: 0.75,
      ease: "power2.out"
    }, "<0.2").from(".header_logo, .language_comp, .menu_button, .cart-button_comp", {
      scale: 0,
      stagger: { amount: 0.1 },
      ease: "power2.out"
    }, "<")

  // intro scrollTrigger

  const introScroll = gsap.timeline({
    scrollTrigger: {
      trigger: ".intro_p",
      start: "top 40%",
      end: "bottom 60%",
      scrub: 0.5,
      ease: "none",
      markers: false
    },
  });

  introScroll.from(".section_intro .intro_p span", {
    opacity: 0.2,
    stagger: 0.5,
    ease: "none"
  }).to(".section_intro .intro_p span", {
    opacity: 0.2,
    stagger: 0.5,
    ease: "none"
  }, "<45")

 

}